"use strict";
$(document).foundation();
(function ($, window) {
    var LRGraphLine = function (a) {};
    LRGraphLine.prototype = {
        initialize: function () {
            this.config();
            this.initEvents();
        },
        initEvents: function () {
            $('.filterGraph button').click(function (event) {
                if (!$(this).hasClass('active')) {
                    var sourceData = $(this).data('qSource');
                    var qId = $(this).data('id');
                    var name = $(this).data('name');
                    var scale = $(this).data('scale');
                    var onlyAxes = $(this).data('onlyAxes');
                    var style = $(this).data('qStyle');
                    var decimals = $(this).data('qDecimals');
                    var graphType = $(this).data('qGraphType') ? $(this).data('qGraphType') : 'line';
                    var take = $(this).data('qTake');
                    window.LRGraphLine.paint(qId, qId, name, scale, style, decimals, graphType, sourceData, take, onlyAxes);
                }
                event.preventDefault();
            });
        },
        config: function () {
            $('.graphic_echart').each(function () {
                var sourceData = $(this).data('qSource');
                var graphId = $(this).attr('id');
                var qId = $(this).data('qId');
                var name = $(this).data('qName');
                var scale = $(this).data('scale');
                var onlyAxes = $(this).data('onlyAxes');
                var style = $(this).data('qStyle');
                var decimals = $(this).data('qDecimals');
                var graphType = $(this).data('qGraphType') ? $(this).data('qGraphType') : 'line';
                var take = $(this).data('qTake');
                graphics[graphId] = echarts.init(document.getElementById(graphId));
                graphics[graphId].setOption(generalOptions);
                window.LRGraphLine.paint(graphId, qId, name, scale, style, decimals, graphType, sourceData, take, onlyAxes);
            });
        },
        paint: function (graphId, qId, name, scale, style, decimals, graphType, sourceData, take, onlyAxes) {
            $(".btfiltergraph[data-id='" + graphId + "']").removeClass("active");
            $(".btfiltergraph[data-id='" + graphId + "'][data-scale='" + scale + "']").addClass("active");

            var url = '/api/quote/historic/' + qId;
            switch (sourceData) {
                case "bvc":
                    url = '/api/quote/bvc-historic/' + qId;
                    break;
                case "dolarSpot":
                    url = '/api/quote/spot-historic';
                    break;
            }
            var params = [];
            if (take) {
                params.push('take='+take);
            }

            if (scale) {
                params.push('scale='+scale);
                graphics[graphId].setOption({
                    grid: {
                        left: '12.5%',
                        right: '10%',
                        bottom: '40',
                        top: '40'
                    }
                });
            } else {
                graphics[graphId].setOption({
                    grid: {
                        left: '0',
                        right: '0',
                        bottom: '40',
                        top: '40'
                    },
                });
            }

            if (onlyAxes) {
                graphics[graphId].setOption({
                    grid: {
                        left: '0',
                        right: '0',
                        bottom: '10',
                        top: '10'
                    },
                    xAxis: {
                        axisLabel: {show: false},
                        axisTick: {show: false},
                        splitLine: {show: false},
                    },
                    yAxis: {
                        axisLabel: {show: false},
                        axisTick: {show: false},
                        splitLine: {show: false},
                    },
                });
            }

            if (graphType === 'bar') {
                graphics[graphId].setOption({
                    tooltip: {
                        formatter: function (params) {
                            return window.LRGraphGeneral.format(params.value, style, decimals) + '<br/>' + params.name;
                        }
                    },
                    xAxis: {
                        axisTick: {
                            alignWithLabel: true
                        },
                        splitLine: {
                            show: false
                        },
                        inverse: true
                    }
                });
            } else {
                graphics[graphId].setOption({
                    tooltip: {
                        trigger: graphType === 'line' ? 'axis' : 'item',
                        formatter: function (params) {
                            var p = params[0];
                            return p.seriesName + '<br/>' + window.LRGraphGeneral.format(p.value, style, decimals) + '<br/>' + p.name;
                        }
                    },
                });

            }

            if (params.length > 0) {
                url += '?';
                params.forEach(function (val, idx) {
                    if (idx == 0) {
                        url += val;
                    }
                    else {
                        url += '&' + val;
                    }
                });
            }

            $.get(url).done(function (data) {
                if (data.values && data.values.length > 1) {
                    if (qId === 24) {
                        window.LRGraphLine.paintUVRMiniTable(data, style, decimals);
                    };

                    graphics[graphId].setOption({
                        xAxis: {
                            data: data.dates
                        },
                        yAxis: {
                            show: onlyAxes ? onlyAxes : scale,
                            axisLabel: {
                                formatter: function (vv, idx) {
                                    var val = window.LRGraphGeneral.format(vv, style, decimals);
                                    return val;
                                }
                            }
                        },
                        series: [{
                            name: name,
                            type: graphType,
                            showSymbol: !scale,
                            label: {
                                show: !scale,
                                normal: {
                                    show: !scale,
                                    formatter: function (params) {
                                        var val = scale ? '' : window.LRGraphGeneral.format(params.value, style, decimals);
                                        return val;
                                    },
                                    position: 'top',
                                    color: '#818282'
                                }
                            },
                            data: data.values
                        }]
                    });
                } else {
                    $(".btfiltergraph[data-id='" + graphId + "'].active").parent().addClass("hide");
                    var nextClick = $(".btfiltergraph[data-id='" + graphId + "'].active").parent().next().children('.btfiltergraph');
                    if (nextClick && nextClick.length > 0) {
                        $(nextClick[0]).trigger('click');
                    }
                }
            });
        },
        paintUVRMiniTable: function (data, style, decimals) {
            if (!$('#UVRMiniTable').html() && data && data.dates.length > 0) {
                var oTable = $('<table></table>');
                oTable.append('<thead><tr><th>FECHA</th><th>PRECIO</th></tr></thead>');

                for (var i = 0; i < 4; i++) {
                    oTable.append('<tr><td>' + data.dates[i] + '</td><td>' + window.LRGraphGeneral.format(data.values[i], style, decimals) + '</td></tr>');
                }
                $('#UVRMiniTable').html(oTable);
            }
        }
    };
    window.LRGraphLine = new LRGraphLine();
    window.LRGraphLine.initialize();
})(jQuery, this, this.document, undefined);